import React, { useEffect, useState } from "react";

// img

// Jds
import { Button, Container, Notifications, Text } from "@jds/core";

// Mui
import { Box, Stack } from "@mui/material";
import AnalyticsCard from "../components/UI/Cards/AnalyticsCard";
import GridContainer from "../components/Layout/GridContainer";
import useApiHttp from "../hooks/use-http";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../components/UI/Loader/PageLoader";
import { bytesToHumanReadable } from "../util/helper";
import AnalyticsChart from "../components/AnalyticsChart/AnalyticsChart";

// Local

export default function AnalyticsPage() {
  // analytics_counts/b50cacd5-b15e-4d76-9409-80a146756681
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { sendRequest: getAnalyticsCounts, isLoading: analyticsCountsLoading } =
    useApiHttp();
  const [eventAnalyticsList, setEventAnalyticsList] = useState([]);
  const [mediaAnalyticsList, setMediaAnalyticsList] = useState([]);
  const [analyticsList, setAnalyticsList] = useState([]);
  const [customFieldAnalytics, setCustomFieldAnalytics] = useState([]);
  useEffect(() => {
    getAnalyticsCounts(
      {
        url: `event-attendee/analytics_counts/${eventId}`,
      },
      null,
      (data) => {
        setEventAnalyticsList([
          {
            title: "Guests",
            analyticsCard: [
              {
                ic: "IcGroup",
                heading: "Total Guests",
                data: data?.data?.allGuestCount,
                onClick: () => {
                  navigate(`/home/events/guests/${eventId}`, {
                    state: { navigate: "ALL" },
                  });
                },
              },
              {
                ic: "IcStamp",
                heading: "Registered Guests",
                data: data?.data?.registeredGuestCount,
                onClick: () => {
                  navigate(`/home/events/guests/${eventId}`, {
                    state: { navigate: "REGISTERED" },
                  });
                },
              },
              {
                ic: "IcRequest",
                // icProps: {
                //   color: "sparkle",
                //   kind: "default",
                //   size: "medium",
                // },
                heading: "Invited Guests",
                data: data?.data?.invitedGuestCount,
                onClick: () => {
                  navigate(`/home/events/guests/${eventId}`, {
                    state: { navigate: "NULL" },
                  });
                },
              },
              {
                ic: "IcSuccess",
                heading: "Approved Guests",
                data: data?.data?.approveGuestCount,
                onClick: () => {
                  navigate(`/home/events/guests/${eventId}`, {
                    state: { navigate: "APPROVED" },
                  });
                },
              },
              {
                ic: "IcCelebration",
                heading: "Attending Guests",
                data: data?.data?.totalAccessingGuestCount,
              },
              {
                ic: "IcBlocked",
                heading: "Blocked Guests",
                data: data?.data?.blockedGuestCount,
                onClick: () => {
                  navigate(`/home/events/guests/${eventId}`, {
                    state: { navigate: "blocked" },
                  });
                },
              },
              {
                ic: "IcError",
                heading: "Denied Guests",
                data: data?.data?.denyGuestCount,
                onClick: () => {
                  navigate(`/home/events/guests/${eventId}`, {
                    state: { navigate: "DENIED" },
                  });
                },
              },
            ],
          },
          {
            title: "Access",
            analyticsCard: [
              {
                ic: "IcAccessibility",
                heading: "Guests with Full Access",
                data: data?.data?.fullAccessCount,
              },
              {
                ic: "IcSmileyNeutral",
                heading: "Guests with Face Access",
                data: data?.data?.faceAccessCount,
              },
              {
                ic: "IcDownload",
                heading: "Guests with Download Access",
                data: data?.data?.approvedDownloadCount,
              },
            ],
          },
          {
            title: "Photographers",
            analyticsCard: [
              {
                ic: "IcGroup",
                heading: "Total Photographers",
                data: data?.data?.allPhotographerCount,
                onClick: () => {
                  navigate(`/home/events/photographers/${eventId}`);
                },
              },
              {
                ic: "IcCalendarEvent",
                heading: "Attending Photographers",
                data: data?.data?.attendingPhotographerCount,
                onClick: () => {
                  navigate(`/home/events/photographers/${eventId}`);
                },
              },
              {
                ic: "IcBlocked",
                heading: "Blocked Photographers",
                data: data?.data?.blockedPhotographerCount,
                onClick: () => {
                  navigate(`/home/events/photographers/${eventId}`, {
                    state: { navigate: "BLOCKED" },
                  });
                },
              },
            ],
          },
        ]);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "analytics_counts",
          title: data.message,
        });
      },
    );

    getAnalyticsCounts(
      {
        url: `analytics/photos?eventId=${eventId}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        setMediaAnalyticsList([
          {
            title: "Event Photos",
            analyticsCard: [
              {
                ic: "IcPhoto",
                heading: "Total Event Photos",
                data: data?.data?.eventPhotosCount,
              },
              {
                ic: "IcPhoto",
                heading: "Guest Photos",
                data: data?.data?.guestPhotosCount,
              },
              {
                ic: "IcCamera",
                heading: "Photographers Photos",
                data: data?.data?.photographerCount,
              },
              {
                ic: "IcPhoto",
                heading: "Approved Guest Photos",
                data: data?.data?.guestApprovedPhotosCount,
              },
              {
                ic: "IcCameraHighEnd",
                heading: "Approved Photographer Photos",
                data: data?.data?.photographerApprovedCount,
              },
            ],
          },
          {
            title: "Faces",
            analyticsCard: [
              {
                ic: "IcSmileySatisfied",
                heading: "Unique Faces",
                data: data?.data?.facesCount,
              },
            ],
          },
          {
            title: "Event Storage",
            analyticsCard: [
              {
                ic: "IcCloud",
                heading: "Event Storage (approx)",
                data:
                  typeof data?.data?.totalFileSizeBytes === "number" &&
                  !isNaN(data?.data?.totalFileSizeBytes) &&
                  data?.data?.totalFileSizeBytes > 0
                    ? bytesToHumanReadable(data?.data?.totalFileSizeBytes)
                    : 0,
              },
            ],
          },
        ]);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "analytics_counts",
          title: data.message,
        });
      },
    );

    getAnalyticsCounts(
      {
        url: `event-attendee/analytics_counts/custom-field/${eventId}`,
      },
      null,
      (data) => {
        setCustomFieldAnalytics(data?.data);
      },
      (err, data) => {
        // console.log('Custom field data', data)
      },
    );
  }, []);

  useEffect(() => {
    if (eventAnalyticsList.length && mediaAnalyticsList.length)
      setAnalyticsList([...eventAnalyticsList, ...mediaAnalyticsList]);
  }, [eventAnalyticsList, mediaAnalyticsList]);
  return (
    <>
      <Container direction="column" gap={8}>
        <Text text="Analytics" appearance="heading-xs" />
        <Text text="Metrics" color="primary_grey_80" appearance="body-m-bold" />
      </Container>
      <div
        style={{
          marginBottom: "24px",
        }}>
        {analyticsList?.map((list, index) => (
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}>
            <Text text={list?.title} appearance="body-m-bold" />
            <GridContainer minWidth={"240px"} repeat={"auto-fill"}>
              {list?.analyticsCard?.map((item, i) => (
                <AnalyticsCard
                  key={i}
                  icon={item?.ic}
                  heading={item?.heading}
                  data={item?.data}
                  icProps={item?.icProps}
                  onClick={item?.onClick}
                />
              ))}
            </GridContainer>
          </div>
        ))}
      </div>
      {customFieldAnalytics.length > 0 && (
        <Box>
          <Container direction="column" gap={8}>
            <Text
              text="Custom Field Metrics"
              color="primary_grey_80"
              appearance="body-m-bold"
            />
          </Container>
          <Box my={2}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit ,minmax(500px,1fr))",
                gap: "16px",
              }}>
              {customFieldAnalytics.map((data, i) => {
                return <AnalyticsChart data={data} />;
              })}
            </div>
          </Box>
        </Box>
      )}
      {analyticsCountsLoading && <PageLoader open={analyticsCountsLoading} />}
    </>
  );
}
